module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "open-container"
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "block-60"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-tabs"
  }, [_c('div', {
    staticClass: "container tab-content"
  }, [_c('div', {
    staticClass: "row tab-pane active",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "panel-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "opendoc_right white_bg"
  }, [_c('div', {
    staticClass: "content2_he"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "menu0 menu_tab"
  }, [_c('div', {
    staticClass: "tab active",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("平台简介")]), _vm._v(" "), _c('p', [_vm._v("\n                                                众联云打印开放平台，为开发者提供各行业的云打印解决方案，致力于成为国内最安全、稳定的云打印服务平台。\n                                                "), _c('br'), _vm._v("平台日均打印小票超过一百万，云打印解决方案可以有效提升商家经营效率、降低经营成本、提升市场竞争力、提高消费者的服务体验。\n                                                "), _c('br'), _vm._v("众联云打印开放平台提供完善的API开发文档以及示例，还有免费的技术支持服务。\n                                                "), _c('br'), _vm._v("接入众联云打印开放平台，让你的应用马上具备云打印功能，随时随地打印，不受距离限制。\n                                                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("平台目前提供两种类型的设备支持：\n                                                "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("（1）普通WiFi / 4G 打印机")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("（2）云盒，一种可以连接蓝牙设备实现云打印的外设")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "menu1 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab1"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("\n                                            开发者接入API步骤如下，如对接遇到问题，请加众联云技术支持微信咨询（请务必备注"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("“开放平台对接”")]), _vm._v("）：\n                                        ")], 1), _vm._v(" "), _c('img', {
    staticClass: "tech-qrcode",
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第一步：注册开发者账号")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第二步：对接API（HTTPS协议）")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            注意:建议先调用添加设备接口，然后再调用打印接口进行打印，这样您可以在开放平台的管理后台查看打印记录。所有API接口都是"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                                                https ")]), _vm._v("\n                                            协议。"), _c('br'), _c('br'), _vm._v("\n                                            1、 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("【必接】")]), _vm._v("绑定设备到开发者账户\n                                        ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "bg-h4"
  }, [_vm._v("第三步：测试打印")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            测试打印之前，请确保设备在线，并且纸张正常。如调试打印模板有问题，请扫描上方技术支持二维码添加技术对接工作人员进行咨询。")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab3"
    }
  }, [_vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "tab_mb f14"
  }, [_vm._v("\n                                            Restful API本质就是发送 HTTP 请求，只不过大家常用的可能是 HTTP GET 和 HTTP POST 请求，但是在 Restful\n                                            API里面还经常用到\n                                            HTTP PUT 、HTTP PACTCH、 HTTP DELETE。\n                                            "), _c('br'), _vm._v("在 Restful\n                                            API中，把这五种操作称之为动词，可以（但不是特别准确）想象成增删改查。客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                            "), _c('br'), _vm._v("Restful API 接口调用成功时返回 HTTP 状态码为 200，如调用错误会返回除 200 之外的其他 HTTP\n                                            状态码，可根据返回数据中的\n                                            code和msg 字段判断具体错误。\n                                            "), _c('br'), _vm._v(" "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("常见HTTP错误状态码如下：")])], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("全局code如下：")]), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('div', {
    staticClass: "menu2 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-1"
    }
  }, [_vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/add")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(可查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备名称/备注")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(16)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(20)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-2"
    }
  }, [_vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/info")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("GET")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求URL参数：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(可查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(23)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(24), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ id")]), _vm._v(" "), _c('td', [_vm._v("long")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备ID\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备编号\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备名称\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ type")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备类型，1：打印机，2：云盒\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ width")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        纸宽，目前只有两个规格 58 或 80\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ iccid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        流量卡号，WiFi机型该值为空\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ online")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备是否在线，1：在线，0：离线\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ status")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        设备自身状态，1：正常，0：异常\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ toPrintCount")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        待打印任务数，默认 0\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ cutAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        是否带切刀，true：带切刀，false：不带切刀\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ vocAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        语音播报开关，true：播报语音，false：不播报语音\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(27)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-3"
    }
  }, [_vm._m(28), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/setting")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("PUT")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(29), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("name")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("修改设备名称\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_c('font', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 【注意】")]), _vm._v("\n                                                        修改设备纸宽，仅限设备是"), _c('font', {
    staticStyle: {
      "color": "red",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 云盒\n                                                        ")]), _vm._v("的时候才生效\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("cutAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_c('font', {
    staticStyle: {
      "color": "blue",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 【注意】")]), _vm._v("\n                                                        修改设备是否有切刀，仅限设备是"), _c('font', {
    staticStyle: {
      "color": "red",
      "font-weight": "bolder"
    }
  }, [_vm._v(" 云盒\n                                                        ")]), _vm._v("的时候才生效\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("vocAble")]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("设置是否播报语音，true：播报语音，false：不播报语音\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(30)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(34)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-4"
    }
  }, [_vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/delete")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(36), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(37)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(38), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(41)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-5"
    }
  }, [_vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/add")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(43), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号(查看设备侧边或底部标签)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("【重要】订单编号，开发者自有系统的订单编号，若需回调打印结果 或\n                                                        主动查询打印任务状态"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("必填")]), _vm._v("，开发者自己保证"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("\n                                                            唯一\n                                                        ")]), _vm._v("性\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("content")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印内容，最大支持 4000 字节（中文按照2字节计算）")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("delay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("延迟打印"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("（单位：秒）")]), _vm._v("，默认为 0，云平台接收到打印任务立即执行")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("expiredDay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务过期时间"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("（单位：天）")]), _vm._v("，默认为\n                                                        1，N天内目标打印设备没有执行打印则任务自动丢弃\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(44)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(45), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ createTime")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        任务接收时间\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        订单编号\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("小票排版控制标签说明：(详情请参考SDK示例)")])], 1), _vm._v(" "), _c('pre', {
    staticClass: "prettyprint linenums prettyprinted"
  }, [_c('ol', {
    staticClass: "linenums"
  }, _vm._l((_vm.$printTags), function(item) {
    return _c('li', {
      key: item.label
    }, [_c('span', {
      staticClass: "hljs-string"
    }, [_vm._v(" " + _vm._s(item.label) + " ")]), _vm._v("：" + _vm._s(item.tips))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(48)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-5"
    }
  }, [_vm._m(49), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/delete")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(50), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务订单号，"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("开发者自有系统的订单编号")]), _vm._v("，下发打印任务时传入\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(51)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(52), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])])])]), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(54), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(55)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-6"
    }
  }, [_vm._m(56), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/clean")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("DELETE")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(57), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sn")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("设备编号")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(58)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(59), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ count")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        清空的任务数\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(62)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-7"
    }
  }, [_vm._m(63), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求url：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("https://open.zonelink.cc/v1/printer/task/status")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("GET")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求数据说明：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            客户端发送到服务端的数据类型为：application/json，服务器返回的数据类型为：applicstion/json，数据编码为：UTF-8。\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求URL参数：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(64), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("打印任务订单号，"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("开发者自有系统的订单编号")]), _vm._v("，下发打印任务时传入\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(65)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("返回参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(66), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("code")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("返回码，正确返回0，【注意：结果正确与否的判断请用此返回参数】，错误返回非零")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("msg")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("结果提示信息，正确返回“ok”，如果有错误，返回错误信息")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_vm._v("object")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        数据类型和内容详看私有返回参数data\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ status")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        打印任务状态，0：待发送至设备，1：已下发至设备，2：设备已接收，3：打印完成，4：被删除，5：延迟打印\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ delay")]), _vm._v(" "), _c('td', [_vm._v("int")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        延迟打印剩余时间，当 status=5 时返回，单位：秒\n                                                    ")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" └ printTime")]), _vm._v(" "), _c('td', [_vm._v("date")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('td', [_vm._v("\n                                                        打印任务完成时间，当 status=3 时返回\n                                                    ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("成功返回：")]), _vm._v(" "), _vm._m(67), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("失败返回：")]), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("本接口code说明：")]), _vm._v(" "), _vm._m(69)]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-8"
    }
  }, [_vm._m(70), _vm._v(" "), _c('div', {
    staticClass: "callback-container"
  }, [_c('div', [_vm._v("\n                                                【说明】此接口是云服务器主动向开发者服务器回传打印任务状态。\n                                            ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                【编码】发送的数据类型为：application/json，数据编码为：UTF-8。\n                                            ")]), _vm._v(" "), _c('div', [_vm._v("\n                                                【前提】需要在开发者后台"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("配置")]), _vm._v("打印任务状态"), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("回调地址\n                                                ")]), _vm._v("\n                                                ，且调用\n                                                "), _c('font', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("“下发打印任务”")]), _vm._v("接口时务必传入"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("orderNo\n                                                ")]), _vm._v("。\n                                            ")], 1), _vm._v(" "), _c('div', [_vm._v("\n                                                【安全】开发者需要根据签名算法对回调地址接收到的数据做安全校验。\n                                            ")])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求方法：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("POST")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求响应：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            开发者接收后需立即返回 "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("SUCCESS")]), _vm._v("\n                                            ，如5秒内不返回或返回数据格式错误，云平台会重新推送，最多重推3次。\n                                        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("请求参数说明：")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(71), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("appid")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("用户唯一凭证")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("timestamp")]), _vm._v(" "), _c('td', [_vm._v("long")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', [_vm._v("请求时unix时间戳(10位数字，精确到秒)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("orderNo")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("开发者自有系统的订单编号，开发者自己保证"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" 唯一\n                                                        ")]), _vm._v("性\n                                                    ")], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("sign")]), _vm._v(" "), _c('td', [_vm._v("string")]), _vm._v(" "), _c('td', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), _vm._m(72)])])]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("开发者响应返回示例：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("SUCCESS")])]), _vm._v(" "), _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab-9"
    }
  }, [_vm._m(73), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("签名生成的通用步骤如下：")]), _vm._v(" "), _vm._m(74), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("特别注意以下重要规则：")]), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('p', [_c('b', [_vm._v("第二步：")]), _vm._v("在 paramString 最后拼接上"), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(" appsecret ")]), _vm._v("\n                                            得到 signString 字符串，并对 signString 进行MD5运算，再将得到的字符串所有字符转换为大写，得到 sign 值\n                                            signValue。\n                                        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("举例：")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("假设传送的参数如下：")]), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            paramString =\n                                            \"appid=jSOrPqkMuxff&key=nBx3XNuXsnTDWSzJ&name=zonelink&sn=Hy7Imeya17id&timestamp=1664267034\";\n                                        ")]), _vm._v(" "), _c('p', {
    staticClass: "t_h5"
  }, [_vm._v("第二步：拼接API密钥：")]), _vm._v(" "), _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            signString = \"paramString&appsecret=WjHdVQ8n7heUUbrKDsNU8Wj5iO6rGRTq\"\n                                            "), _c('br'), _vm._v("sign = MD5(signString).toUpperCase()\n                                            "), _c('br'), _vm._v("得到最终结果："), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("F35BED40E66CF30C896ECF34D145C1E2")])], 1), _vm._v(" "), _c('p', {
    staticClass: "t_h5",
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("注意：appid 和 appsecret 的值，请登陆管理后台查看开发者信息")])])]), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opendoc_left"
  }, [_c('div', {
    staticClass: "tools-nav white_bg"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('h3', {
    staticClass: "onleft"
  }, [_vm._v("一. 平台介绍")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu0",
    staticStyle: {
      "display": "block"
    }
  }, [_c('li', [_c('a', {
    staticClass: "selected"
  }, [_vm._v("平台简介")])]), _vm._v(" "), _c('li', [_c('a', {}, [_vm._v("开放平台管理规则")])])]), _vm._v(" "), _c('h3', {}, [_vm._v("二. 开发者对接说明")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu1",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('a', {}, [_vm._v("对接步骤")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("公共参数说明")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Restful 介绍 & 全局返回码")])])]), _vm._v(" "), _c('h3', {}, [_vm._v("三. 接口列表")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu2",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', [_c('a', {}, [_vm._v("添加设备")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("获取设备信息")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("设置设备信息")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("删除设备")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("小票机下发打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("删除指定打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("清空设备待打印任务")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("查询打印任务状态")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "callback"
    }
  }, [_c('a', [_vm._v("打印成功后回调")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "qm_href"
    }
  }, [_c('a', [_vm._v("\n                                                签名生成算法\n                                            ")])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "sdk_href"
    }
  }, [_vm._v("四. SDK 示例下载")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu4"
  }, [_c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "selected",
    attrs: {
      "href": "https://www.zonelink.cc/open/index.html#tab4-1"
    }
  }, [_vm._v("SDK\n                                                示例下载")])])]), _vm._v(" "), _c('h3', [_vm._v("五. 常见问题")]), _vm._v(" "), _c('ul', {
    staticClass: "ulmenu5"
  }, [_c('li', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    staticClass: "selected",
    attrs: {
      "href": "https://www.zonelink.cc/open/index.html#tab5-1"
    }
  }, [_vm._v("常见问题")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "get-menu"
  }, [_c('h4', {
    staticClass: "nav_title A1"
  }, [_vm._v("平台介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "src": "/static/img/process.jpg",
      "alt": "云打印流程"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("开放平台运营管理规则")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("1.相关定义")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("众联云打印开放平台")]), _vm._v("：众联云打印开放平台（以下简称“开放平台”），众联云，为第三方提供：技术文档、应用程序等相关服务，帮助其使用众联云打印服务。\n                                            ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("第三方")]), _vm._v("：指与开放平台合作的任何第三方，包括但不限于个人开发者、企业开发者、以及个人或企业开发者的关联公司、合作方。\n                                            ")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("2.开放平台接入流程")]), _vm._v(" "), _c('h5', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("接入指南")]), _vm._v(" "), _c('p', [_vm._v("第一步：注册（开发者的账号密码具有唯一性，开发者需对账号下的一切操作承担全部责任与法律后果）；")]), _vm._v(" "), _c('p', [_vm._v("第二步：阅读并确认了解《众联云打印开放平台服务条款》；")]), _vm._v(" "), _c('p', [_vm._v("第三步：完善第三方信息；")]), _vm._v(" "), _c('p', [_vm._v("第四步：根据接口文档进行开发；")]), _vm._v(" "), _c('p', [_vm._v("第五步：开发测试；")]), _vm._v(" "), _c('p', [_vm._v("第六步：上线；")]), _vm._v(" "), _c('h4', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("3.免责声明")]), _vm._v(" "), _c('h5', {
    staticClass: "subtitle",
    attrs: {
      "id": ""
    }
  }, [_vm._v("条款")]), _vm._v(" "), _c('p', [_vm._v("（1）对于使用了开放平台提供服务的第三方，必须遵守法律法规，如有违反，第三方同意独立承担所有的风险和后果。")]), _vm._v(" "), _c('p', [_vm._v("（2）第三方将使用了开放平台提供服务后的系统提供给最终用户使用时，应充分告知其相关注意事项。因任何人使用第三方开发或运营的系统所产生的任何问题、事故或纠纷，均由第三方自行承担全部责任，开放平台对此不承担责任。\n                                            ")]), _vm._v(" "), _c('p', [_vm._v("（3）开放平台因本条前述事由受到损失或者被要求承担责任的，有权要求相应第三方赔偿开放平台因此受到的损失和/或要求该开发者承担相关责任。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tab_mb",
    staticStyle: {
      "color": "#999",
      "border-radius": "0 0 5px 5px"
    }
  }, [_vm._v("\n                                            到\n                                            "), _c('a', {
    staticClass: "font_0071",
    attrs: {
      "href": "/login",
      "target": "_blank"
    }
  }, [_vm._v("https://www.zonelink.cc/login")]), _vm._v("\n                                            （以下统称‘众联云开放后台’）注册开发者账号。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("请求公共参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("返回公共参数")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("Restful API 介绍")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("HTTP 返回码（Status Code）")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("400")]), _vm._v(" "), _c('td', [_vm._v("（错误请求）服务器不理解请求的语法。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("401")]), _vm._v(" "), _c('td', [_vm._v("（未授权）请求要求身份验证。对于需要sign的接口，服务器可能返回此响应。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("403")]), _vm._v(" "), _c('td', [_vm._v("（禁止）服务器拒绝请求。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("404")]), _vm._v(" "), _c('td', [_vm._v("（未找到）服务器找不到请求的接口。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("408")]), _vm._v(" "), _c('td', [_vm._v("（请求超时）服务器等候请求时发生超时。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("413")]), _vm._v(" "), _c('td', [_vm._v("（请求体过大）拆成更小的请求体重试即可。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("500")]), _vm._v(" "), _c('td', [_vm._v("（服务器内部错误）请求参数不正确或服务器遇到错误，无法完成请求。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("501")]), _vm._v(" "), _c('td', [_vm._v("（尚未实施）服务器不具备完成请求的功能。例如，服务器无法识别请求方法时可能会返回此代码。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("502")]), _vm._v(" "), _c('td', [_vm._v("（错误网关）服务器作为网关或代理，从上游服务器收到无效响应。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("503")]), _vm._v(" "), _c('td', [_vm._v("（服务不可用）请求接口超过调用频率限制，即接口被限流。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("504")]), _vm._v(" "), _c('td', [_vm._v("（网关超时）服务器作为网关或代理，但是没有及时从上游服务器收到请求。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                                            更多 Restful API 背景知识可以参考\n                                            "), _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "https://www.ruanyifeng.com/blog/2014/05/restful_api.html",
      "target": "_blank"
    }
  }, [_vm._v("Restful API 设计指南。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("成功")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-1")]), _vm._v(" "), _c('td', [_vm._v("请求参数不正确")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-2")]), _vm._v(" "), _c('td', [_vm._v("appid不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-3")]), _vm._v(" "), _c('td', [_vm._v("签名错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("-4")]), _vm._v(" "), _c('td', [_vm._v("请求超时")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("10000")]), _vm._v(" "), _c('td', [_vm._v("开发者信息错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("大于0")]), _vm._v(" "), _c('td', [_vm._v("错误码大于0时每个接口返回不一样，具体请看各个接口")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("添加设备")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备编号为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备KEY为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("设备名称为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("设备编号或KEY错误")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("此设备已添加，不能重复添加")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("获取设备信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v(" {")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("               "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备编号")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"sn\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"Hy7Imeya17id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("  "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备编号")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"name\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"zonelink\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("    "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备名称")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"type\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("             "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 设备类型，1：打印机，2：云盒")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("58")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 纸宽，目前只有两个规格 58 和 80")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"imsi\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"xxx\"")])]), _vm._v("          "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 流量卡号码,wifi机型该值为空")])])]), _c('li', {
    staticClass: "L4"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"online\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 是否在线，1：在线：0：离线")])])]), _c('li', {
    staticClass: "L5"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("           "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 状态，1：正常，0：异常")])])]), _c('li', {
    staticClass: "L6"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"toPrintCount\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("     "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 待打印任务数")])])]), _c('li', {
    staticClass: "L7"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"cutAble\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("false")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("      "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 是否带切刀，true：带切刀，false：不带切刀")])])]), _c('li', {
    staticClass: "L8"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("              ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vocAble\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("true")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v("       "), _c('span', {
    staticClass: "c666"
  }, [_vm._v("// 语音播报开关，true：播报语音，false：不播报语音")])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("       ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("}")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("设置设备信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("非云盒纸宽设置无效")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("非云盒切刀设置无效")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("至少必须存在一项编辑项")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("删除设备")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("系统繁忙")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("小票机下发打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("{")])])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"createTime\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022-10-10 00:00:00\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"orderNo\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022101000001\"         // 如果开发者不传入，云平台会自动生成订单号，但是打印结果不会回调")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("}")])])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("设备编号SN不正确")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("打印内容为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("打印内容长度超过4000字节")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("需要回调所以客户订单号不可为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("订单号长度超过64")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("删除指定打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("\"ok\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("暂无权限")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("清空指定设备待打印任务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v(" ")]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")]), _vm._v(" ")]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("{")])])]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"count\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("10")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_vm._v("}")])]), _c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("暂无权限")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("设备不存在")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("查询打印任务状态")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("0")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"ok\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"data\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("3")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("             ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"printTime\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"2022-10-10 00:00:00\"")])])])]), _c('li', {
    staticClass: "L9"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("}")])])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])]), _vm._v("\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"code\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "lit"
  }, [_vm._v("-1")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"msg\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', [_vm._v("\"appid为空\"")])])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("code")]), _vm._v(" "), _c('th', [_vm._v("说明（Description）")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("订单号为空")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("查无此订单号对应的打印任务")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("延迟打印失败")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("打印成功后回调")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("是否必须")]), _vm._v(" "), _c('th', [_vm._v("说明")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("\n                                                        签名，\n                                                        "), _c('a', {
    staticClass: "qm_href",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("详见签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spdown-body"
  }, [_c('h3', {
    staticClass: "content-title"
  }, [_vm._v("签名生成算法")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("第一步：")]), _vm._v("设所有发送或者接收到的数据为集合M，将集合M内非空参数值的参数按照参数名ASCII码从小到大排序（字典序），使用URL键值对的格式（即key1=value1&key2=value2…）拼接成字符串\n                                            paramString。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tab_mb"
  }, [_vm._v("\n                                            ◆ 参数名ASCII码从小到大排序（字典序）；\n                                            "), _c('br'), _vm._v("◆ 如果参数的值为空不参与签名，注意为空指空字符串，\"0\"不为空字符串，需参与签名；\n                                            "), _c('br'), _vm._v("◆ 参数名区分大小写；\n                                            "), _c('br'), _vm._v("◆ 验证调用返回或微信主动通知签名时，传送的sign参数不参与签名，将生成的签名与该sign值作校验。\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "prettyprint linenums prettyprinted f14"
  }, [_c('ol', {
    staticClass: "linenums"
  }, [_c('li', {
    staticClass: "L0"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("{")])])]), _c('li', {
    staticClass: "L1"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"appid\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"jSOrPqkMuxff\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L2"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"timestamp\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"1664267034\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L3"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"sn\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Hy7Imeya17id\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L4"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"key\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"nBx3XNuXsnTDWSzJ\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(",")])])]), _c('li', {
    staticClass: "L5"
  }, [_c('code', {
    staticClass: "hljs bash"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("      ")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"name\"")])]), _c('span', {
    staticClass: "pun"
  }, [_vm._v(":")]), _c('span', {
    staticClass: "str"
  }, [_c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"zonelink\"")])])])]), _c('li', {
    staticClass: "L6"
  }, [_c('code', {
    staticClass: "hljs"
  }, [_c('span', {
    staticClass: "pln"
  }, [_vm._v("  ")]), _c('span', {
    staticClass: "pun"
  }, [_vm._v("}")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "t_h5"
  }, [_c('b', [_vm._v("第一步：")]), _vm._v("对参数按照key=value的格式，并按照参数名ASCII字典序排序如下：\n                                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu4 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab4-1"
    }
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/java.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-Java版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/java-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/php.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-PHP版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/php-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/nodejs.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-NodeJS版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/nodejs-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/python.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-Python版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/python-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "thumbnail"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "/static/img/weixin.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h4', [_vm._v("众联云API-微信小程序版")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-un_default",
    attrs: {
      "href": "https://static.zonelink.cc/openapi-sdk/wx-sdk.zip",
      "target": "_blank"
    }
  }, [_vm._v("点击下载")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning m20 tc"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("如有其他技术问题，请扫描下方技术支持二维码添加技术对接工作人员进行咨询。")]), _vm._v(" "), _c('img', {
    staticClass: "tech-qrcode",
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "src": "/static/img/tech.jpg",
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu5 menu_tab"
  }, [_c('div', {
    staticClass: "tab",
    attrs: {
      "id": "tab5-1"
    }
  }, [_c('div', {
    staticClass: "clearfix row help"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content2_he"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "panel"
    }
  }, [_c('div', {
    staticClass: "panel panel-default current"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        1、VIP开发者和普通开发者的区别\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("VIP开发者有更多的接口权限，更长的订单保存时间等功能。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        2、设备单行打印多少个字符\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("众联云58mm系列云设备,一行打印16个汉字/32个字母\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        3、如何设置订单小票格式\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("参考开发文档,“打印任务”接口")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        4、二维码的大小是否可以调整\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("大小不能调整,根据内容的长度,动态生成")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        5、4G型号机器需要充值吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("要，机器从购买日起，送一年的4G流量费，过期后需要充值。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        6、无线设备断网了，订单会漏吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                                                        不会漏单，由于网络异常情况导致设备离线，设备会不断的自动重连，订单是缓存在服务器上面的，机器重新联网后会继续打印之前未打印的订单。\n                                                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        7、打印任务的时候,刚好没纸了,会自动补打吗\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("会,重新装上纸后,会重新补打一份。")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('a', {
    staticClass: "panel-title"
  }, [_vm._v("\n                                                                        8、机器出现故障如何保修\n                                                                        "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse panel-coll2"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                                                        先电话或微信咨询客服，确认问题，非人为因素机器免费保修一年。人为因素要收取一定维修费用。维修统一寄回工厂处理。\n                                                                    ")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b57448a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/open.vue
// module id = 346
// module chunks = 1